import {
  RESET_ADDRESS,
  SET_ADDRESS,
  SET_ADDRESS_VALIDITY,
  SET_SUGGESTIONS,
  SET_VISIBILITY,
  SET_NOT_COVERED_ADDRESS,
  SET_TIME_IN_COVERAGE,
  SET_COVERAGE_TYPE
} from './types';

export default {
  [RESET_ADDRESS](state) {
    state.selectedAddress = {};
    state.isValid = false;
  },

  [SET_ADDRESS](state, data) {
    state.selectedAddress = data;
    state.isValid = true;
  },

  [SET_ADDRESS_VALIDITY](state, data) {
    state.isValid = data;
  },

  [SET_SUGGESTIONS](state, data) {
    state.suggestions = data;
  },

  [SET_VISIBILITY](state, data) {
    state.isVisible = data;
  },

  [SET_NOT_COVERED_ADDRESS](state, data) {
    state.notCovered = data;
  },

  [SET_TIME_IN_COVERAGE](state) {
    state.timesInCoverage += 1;
  },

  [SET_COVERAGE_TYPE](state, data) {
    state.coverageType = data;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/addresses/mutations.js